import { ComponentFactoryResolver, Injectable } from "@angular/core";
import { Observable, from, BehaviorSubject, fromEvent, merge, of } from "rxjs";
import { sigUserModel } from "src/app/Models/sigUserModel";
import { Usercredentiel } from "src/app/Pages/login/login.page";
import {
  Platform,
  NavController,
  AlertController,
  LoadingController,
  ToastController,
  ModalController,
} from "@ionic/angular";
import { Storage } from "@ionic/storage";
import { AngularFireAuth } from "@angular/fire/auth";

import { AngularFireDatabase } from "@angular/fire/database";
import { Router } from "@angular/router";
import { SqlitebaseService } from "../Sqlite/Sqlitebase.service";
import { Network } from "@ionic-native/network/ngx";

import { mapTo } from "rxjs/operators";
import { AppVersion } from "@ionic-native/app-version/ngx";
import { exit } from "process";
import { trackingModel } from "src/app/Models/trackingModel";
import { FactoryService } from "../historique/factory.service";
import {
  HttpClient,
  HttpErrorResponse,
  HttpHeaders,
} from "@angular/common/http";
import { error } from "console";
import { environment } from "src/environments/environment.prod";

const PROFIL = "TOKEN";
export interface Clients {
  register_id?: string;
  NomPrenom?: string;
  datestatus?: string;
  name?: string;
  prenom?: string;

  status?: string;

  uid?: string;
  tel1?: string;
  tel2?: string;
  key?: string;
}
@Injectable({
  providedIn: "root",
})
export class authenticationService {
  authenticateState = new BehaviorSubject(false); // quittance[]=any
  politique = new BehaviorSubject(false);
  userCode: string;
  profile: Clients;
  clientUID: string;
  private clientKey: string;
  loading: HTMLIonLoadingElement;
  isLogin: boolean;
  param_switch_view = new BehaviorSubject("");
  tracking: trackingModel;

  //private dataStore: { quittances: any[] } = { quittances: [] };
  //readonly quittances = this._quittances.asObservable();
  private TOKEN_KEYREAL: string;
  private online$: Observable<boolean> = undefined;

  constructor(
    private storage: Storage,
    private plt: Platform,
    private afAuth: AngularFireAuth,
    private autoSQL: SqlitebaseService,
    private db: AngularFireDatabase,
    private appVersion: AppVersion,
    private toastController: ToastController,
    private Network: Network,
    private fact: FactoryService,
    private nvCtrl: Router,
    private httpClient: HttpClient,
    private loadingController: LoadingController
  ) {
    this.online$ = Observable.create((observer) => {
      observer.next(true);
    }).pipe(mapTo(true));

    if (this.plt.is("cordova")) {
      // on Device
      this.online$ = merge(
        this.Network.onConnect().pipe(mapTo(true)),
        this.Network.onDisconnect().pipe(mapTo(false))
      );
    } else {
      // on Browser
      this.online$ = merge(
        of(navigator.onLine),
        fromEvent(window, "online").pipe(mapTo(true)),
        fromEvent(window, "offline").pipe(mapTo(false))
      );
      // console.log(this.online$);
    }

    // this.Network.onConnect().subscribe(
    //   () =>{
    //     setTimeout(() => {
    //       console.log(this.Network.type);

    //           if (this.Network.type==="") {

    //           }
    //     }, 300);
    //   }
    // )

    this.autoSQL.getDatabaseState().subscribe((val) => {
      // console.log(val);
    });

    
  }
  public getNetworkType(): string {
    return this.Network.type;
  }

  chekMiseAjourVersion() {
    let versionDeploy = "";
    this.checkVersion().then((result) => {
      versionDeploy = result.val();
      this.storage.set("Version_bia", result.val()).then(() => {
        if (versionDeploy) {
          this.appVersion
            .getVersionNumber()
            .then((appVersion) => {
              if (appVersion !== versionDeploy) {
                window.open(
                  "https://play.google.com/store/apps/details?id=ga.nsiagabon.nsiabiabia",
                  "_system",
                  "location=no"
                );
                navigator["app"].exitApp();
              }
            })
            .catch((error) => {
              //console.error(error); => cordova_not_available
            });
        }
      });
      //console.log(result.val())}
    });
  }

  public getNetworkStatus(): Observable<boolean> {
    return this.online$;
  }
  async updateToken(token: string, uid) {
    if (!token) return;
    this.db
      .list("CLIENTS", (ref) => ref.orderByChild("uid").equalTo(uid))
      .snapshotChanges(["child_added"])
      .subscribe((actions) => {
        let List = [];
        List = actions.map((c) => {
          return { key: c.payload.key };
        });
        // List=actions.map(c => ({key: c.payload.key}))
        if (List.length > 0) {
          this.profile.key = List[0].key;
          this.db.object(`CLIENTS/${this.profile.key}`).update({
            register_id: token,
          });
        }
      });
  }
  private async affectePrime() {
    this.db
      .list("Quittances", (ref) =>
        ref.orderByChild("NumTel1").equalTo(this.profile.tel1)
      )
      .snapshotChanges()
      .subscribe((actions) => {
        let List = [];
        List = actions.map((c) => {
          return { key: c.payload.key };
        });
        if (List.length > 0) {
          this.db.object("Quittances").update({
            idKey: this.profile.uid,
            NumTel1: "",
          });
        }
      });
  }
  async presentToast(msg, head = "Statut identification") {
    const toast = await this.toastController.create({
      animated: true,
      //closeButtonText: 'Ok',
      // color: 'danger',
      cssClass: "toast-success",
      duration: 3 * 1000,
      header: head,
      // keyboardClose: true,
      message: msg,
      mode: "ios",
      position: "bottom",
      //showCloseButton: true,
      translucent: true,
    });
    toast.present();
  }

  isAuthToswitch() {
    this.afAuth.authState.subscribe((res) => {});
  }
  /**
   * this function will be use to enter the new costumer doesn't have
   * the numclient
   * @param user the user object
   */
  async addclient(user: any) {
    await this.db.list("CLIENTS").push(user);
  }

  async onRegiter(userModel: sigUserModel) {
    // appel de l'api de création de compte

    this.loading = await this.loadingController.create({
      message: "Tentative d'enregistrement...",
      duration: 30000,
      mode: "ios",
      spinner: "bubbles",
    });

    await this.loading.present();

    try {
      let reg = RegExp("^[0-9]{9}$");
      let val = reg.test(userModel.tel1);
      if (!val) {
        userModel.tel1 = "0" + userModel.tel1;
      }

      const resp = await this.afAuth.auth.createUserWithEmailAndPassword(
        userModel.tel1 + environment.RACINE,
        userModel.password
      );
      if (resp) {
        this.addclient({
          NomPrenom: userModel.name + " " + userModel.prenom,
          email: userModel.email,
          name: userModel.name.trim(),
          prenom: userModel.prenom,
          status: "offline",
          tel1: userModel.tel1,
          tel2: userModel.tel2,
          uid: resp.user.uid,
          datestatus: new Date().toISOString(),
        }).then(() => {
          this.loading.dismiss();
          this.presentToast(
            "Vous êtes enregistré avec succès",
            "Bienvenue sur NSIA Bia Bia"
          );
          // localStorage.setItem('showtuto','yes')
          
          // Enregistrement de L0
          this.fact.seTtracking(
            new Date().toISOString(),
            "L0:create costumer",
            false,
            "1000",
            "",
            "",
            ""
          );
          this.nvCtrl.navigate(["/login"]);
          this.param_switch_view.next(userModel.tel1);

          // this.nvCtrl.navigate(['/login', userModel.tel1])
        });
      } else {
        this.loading.dismiss();
        this.presentToast("");
      }
    } catch (error) {
      console.error(error);
      this.loading.dismiss();
      if (error.code == "auth/email-already-in-use") {
        this.presentToast("Ce numéro de téléphone a déjà été utilisé");
      } else {
        this.presentToast(error);
      }
    }
  }

  async changePass(email: string): Promise<any> {
    const resp = await this.afAuth.auth
      .sendPasswordResetEmail(email)
      .then(() => {
        this.nvCtrl.navigate(["login"]);
      })
      .catch((error) => {
        console.log(error.message);
      });
  }

  async checkExiting(userModel: sigUserModel): Promise<any> {
    const refer = this.db.database.ref();
    const ref2 = refer.child("CLIENTS/");
    var resultat = await ref2
      .orderByChild("numClient")
      .equalTo(userModel.tel1)
      .limitToFirst(1)
      .once("value", (snapshot) => {
        return snapshot.val();
      });

    return resultat.val();
  }
 

  async checkVersion(): Promise<any> {
    const refer = this.db.database.ref();
    const ref2 = refer.child("Version_bia");
    return await ref2.once("value", (snapshot) => {
      return snapshot.val();
    });

    // return resultat.val()
  }

  private async ProfilUser(uid: string) {
    const tree = this.db.database.ref();
    const ref2 = tree.child("CLIENTS/");

    await ref2
      .orderByChild("uid")
      .equalTo(uid)
      .limitToFirst(1)
      .once("child_added", (snapshot) => {
        const $key = snapshot.key; // clé hashée
        this.clientKey = $key;
        tree.child(`CLIENTS/${$key}`).once("value", (snap) => {
          this.profile = snap.val(); //as Clients;
          this.profile.key = this.clientKey;
          this.affectePrime();
          this.storage.remove(PROFIL).then(() => {
            this.storage.set(PROFIL, this.profile).then(
              () => {
                // this.nvCtrl.navigate(['/menu-principal'])
                //this.nvCtrl.navigate(['/menu'])

                this.updateStatus("online");
                // this.updateToken(this.profile.register_id)
                this.authenticateState.next(true);
              },
              (error) => console.error("erreur storage", error)
            );
          });
        });
      });
  }

  async onAuthenicated(userCredentialModel: Usercredentiel): Promise<boolean> {
    this.loading = await this.loadingController.create({
      message: "Tentative de connexion...",
      duration: 30000,
      mode: "ios",
      spinner: "bubbles",
    });

    await this.loading.present();

    let ok = false;
    try {
      const result = await this.afAuth.auth.signInWithEmailAndPassword(
        userCredentialModel.idClient.trim() + environment.RACINE,
        userCredentialModel.password
      );
      if (result) {
        //Récuperer les données liées au client notamment son identité
        this.clientUID = result.user.uid;
        try {
          // result.user.email.substring(0, 5).toUpperCase()

          localStorage.setItem("STATE", "true");
          localStorage.setItem('showtuto','yes')

          await this.ProfilUser(result.user.uid);
          ok = true;
        } catch (error) {
          console.error(error);
        }
      }
    } catch (error) {
      //console.error(error);
      if (
        error.code == "auth/user-not-found" ||
        error.code == "auth/wrong-password"
      ) {
        this.loading.dismiss();
        // console.log('Votres identité n\'existe pas sur Asapp')
      }
    }

    return ok;
  }

  private updateOnConnect() {
    return this.db
      .object(".info/connected")
      .valueChanges()
      .subscribe((connected) => {
        let status = connected ? "online" : "offline";
        // this.updateStatus(status)
      });
  }

  private async updateStatus(status: string) {
    if (!this.clientKey) return;

    await this.db.object(`CLIENTS/${this.clientKey}`).update({
      status: status,
      uid: this.clientUID,
      datestatus: new Date().toISOString(),
    });
  }

  async onLogout() {
    localStorage.setItem("STATE", "false");

    /*--------------------------------------
2022-02-10T 12:53:30.000-05:00
-----------------------------------------*/

    const res = await this.storage.get(PROFIL);

    if (res) {
      this.updateStatus("offline").then(() => {
        this.storage.remove(PROFIL).then(() => {
          this.afAuth.auth.signOut().then(() => {
            try {
              console.log("Executé");
              this.param_switch_view.next(this.profile.tel1);
              this.nvCtrl.navigate(["/login"]);
              //  if (this.plt.is("ios") || this.plt.is("android")) {
              //   //navigator['app'].exitApp()

              //  }

              //this.authenticateState.next(false);
            } catch (error) {}
          });
        });
      });
    } else {
      this.afAuth.auth.signOut().then(() => {
        // if (this.plt.is("ios") || this.plt.is("android")) {

        //   navigator['app'].exitApp()
        //  }else
        this.nvCtrl.navigate(["/login"]);
      });
    }
  }
  //permet de savoir si l'user est authentifié
  isAuthenticated(path: string) {
    const loggedIn = localStorage.getItem("STATE");
    if (loggedIn === "true") {
      this.isLogin = true;
      if (!this.profile) this.AnalizeToken(path);
    } else {
      this.isLogin = false;
    }
    return this.isLogin;
  }

  async recover_user(objetData) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Origin": "*",
        "Content-type": "application/json",
      }),
    };
    return await this.httpClient.post(
      environment.API_URL_RECOVER,
      objetData,
      httpOptions
    );
  }

  async verify_user(objetData) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Origin": "*",
        "Content-type": "application/json",
      }),
    };
    return await this.httpClient.post(
      environment.API_URL_VERIFY_DEMO,
      objetData,
      httpOptions
    );
  }

  AnalizeToken(path: string) {
    this.afAuth.authState.subscribe((user) => {
      if (user) {
        // console.log(user.email.substr(0,5));
        this.clientUID = user.uid;
        this.userCode = user.email.substr(0, 5);
        //this.ProfilUser(this.userCode)
        this.storage.get(PROFIL).then((res) => {
          if (res) {
            this.profile = res;
            //this.authenticateState.next(true)
            if (path === "/menu") this.updateStatus("online");
          }
        });
      }
    });

  }
}
